import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './AccordeonBlock.module.css';

const AccordeonBlock = ({ block }) => {
  const [openItems, setOpenItems] = useState([]);
  
  const toggleItem = (itemId) => {
    setOpenItems(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };
  
  // Trier les items par position
  const sortedItems = [...block.items].sort((a, b) => a.position - b.position);
  
  return (
    <div className={styles.accordeonBlock}>
      {block.title && <h2 className={styles.blockTitle}>{block.title}</h2>}
      {block.description && <p className={styles.blockDescription}>{block.description}</p>}
      
      <div className={styles.accordeonContainer}>
        {sortedItems.map((item) => (
          <div key={item.id} className={styles.accordeonItem}>
            <button 
              className={styles.accordeonHeader}
              onClick={() => toggleItem(item.id)}
              aria-expanded={openItems.includes(item.id)}
              aria-controls={`accordeon-content-${item.id}`}
            >
              <span className={styles.accordeonTitle}>{item.title}</span>
              <span className={styles.accordeonIcon}>
                {openItems.includes(item.id) ? '−' : '+'}
              </span>
            </button>
            
            {openItems.includes(item.id) && (
              <div 
                id={`accordeon-content-${item.id}`}
                className={styles.accordeonContent}
                role="region"
              >
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

AccordeonBlock.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
        position: PropTypes.number,
      })
    ).isRequired,
  }).isRequired,
};

export default AccordeonBlock;






